import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import {
    asyncGetEmailSendingByAccount,
    EmailSendingRecord,
} from '../../../../../../../services/emailSending.service';
import { TableTooltip } from '../../../../../../components/general/table';
import DateTimeFormat from '../../../../../../components/dateTimeFormat';
import { Typography } from '@mui/material';

export const useEmailSendingHistory = (
    accountId?: string,
    enabled = false
) => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<EmailSendingRecord[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<EmailSendingRecord>[] = [
        {
            field: 'created_at',
            headerName: 'Fecha de envío',
            minWidth: 140,
            flex: 0.6,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.created_at} />,
        },
        {
            field: 'subject',
            headerName: 'Asunto',
            minWidth: 150,
            flex: 0.8,
            renderCell: (row) => <TableTooltip value={row.row.subject || ''} />,
        },
        {
            field: 'recipient',
            headerName: 'Destinatario',
            minWidth: 150,
            flex: 0.7,
            renderCell: (row) => (
                <TableTooltip value={row.row.recipient || ''} />
            ),
        },
        {
            field: 'caseId',
            headerName: 'ID Caso',
            minWidth: 130,
            flex: 0.6,
            renderCell: (row) => <TableTooltip value={row.row.caseId || ''} />,
        },
        {
            field: 'createdBy',
            headerName: 'Enviado por',
            minWidth: 140,
            flex: 0.6,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.createdBy
                            ? `(${row.row.createdBy.username}) ${row.row.createdBy.name} ${row.row.createdBy.surname}`
                            : ''
                    }
                />
            ),
        },
        {
            field: 'result',
            headerName: 'Resultado',
            minWidth: 120,
            flex: 0.5,
            renderCell: (row) => {
                const response = row.row.response;
                const success =
                    response?.statusCode === 200 ||
                    Boolean(response?.deliveryId);

                if (!response)
                    return <Typography color="text.secondary">Sin respuesta</Typography>;

                return success ? (
                    <Typography color="success.main">Exitoso</Typography>
                ) : (
                    <Typography color="error.main">Fallido</Typography>
                );
            },
        },
        {
            field: 'deliveryId',
            headerName: 'Delivery ID',
            minWidth: 130,
            flex: 0.6,
            renderCell: (row) => (
                <TableTooltip
                    value={row.row.response?.deliveryId || '-'}
                />
            ),
        },
    ];

    useEffect(() => {
        if (!enabled || !accountId) return;

        setLoading(true);
        asyncGetEmailSendingByAccount(accountId, page, pageSize)
            .then((res) => {
                setRows(res.data);
                setTotal(res.total);
            })
            .finally(() => setLoading(false));
    }, [enabled, accountId, page, pageSize]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};